export const FETCH_INDICATORS = "FETCH_INDICATORS"
export const FETCHED_INDICATORS = "FETCHED_INDICATORS"
export const SEARCH_INDICATORS = "SEARCH_INDICATORS"
export const SELECT_INDICATOR = "SELECT_INDICATOR"
export const SELECT_ALL_INDICATORS = "SELECT_ALL_INDICATORS"
export const SELECT_INDICATOR_ON_RESULT = "SELECT_INDICATOR_ON_RESULT"

export function fetchIfNededIndicators() {


  return (dispatch, getState) => {

    if (getState().indicatorsReducer.indicators.length > 0) {
      return;
    }

    dispatch(fetchIndicators())

    return fetch('/ndap/national-data/variables', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: getState().internationalizationReducer.activeLangCode
      }
    }).then((response) => {
        if (!response.ok)
          throw Error(response.statusText)
        return response
      }).then((response) => response.json())
      .then((responseJson) => {
        dispatch(fetchedIndicators(responseJson))
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

export function fetchIndicators() {
  return { type: FETCH_INDICATORS };
}

export function fetchedIndicators(data) {
  return { type: FETCHED_INDICATORS, data }
}

export function searchIndicators(searchParameter, activeLangCode) {
  return { type: SEARCH_INDICATORS, searchParameter, activeLangCode }
}

export function selectIndicator(indicatorId) {
  return { type: SELECT_INDICATOR, indicatorId }
}

export function selectAllIndicators(selectionStatus) {
  return { type: SELECT_ALL_INDICATORS, selectionStatus }
}

export function selectIndicatorOnResult(indicatorId) {
  return { type: SELECT_INDICATOR_ON_RESULT, indicatorId }
}


// WEBPACK FOOTER //
// ./src/features/modules/survey-data-visualization/indicators/IndicatorsActions.js